import { useRouter } from "next/router";
import { useCallback } from "react";

export function useBuildId() {
  const { basePath } = useRouter();
  const shouldReload = useCallback(async () => {
    if (process.env.NODE_ENV === "development") {
      return false;
    }
    try {
      const buildId = JSON.parse(
        document.querySelector("#__NEXT_DATA__").textContent
      )?.buildId;

      const res = await fetch(
        `${basePath}/api/buildid?id=${buildId}`
      ).then((data) => data.json());
      return !res.result;
    } catch (e) {
      console.log(e);
      return false;
    }
  }, []);
  return { shouldReload };
}
